{
  "version": 1,
  "asset_id": "4194b42b-7b49-4149-ba87-ba8f62f7709c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/4194b42b-7b49-4149-ba87-ba8f62f7709c/sleeve-ugi-reflux-post-1206-es.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/4194b42b-7b49-4149-ba87-ba8f62f7709c/sleeve-ugi-reflux-post-1206-es.jpg",
  "original_filename": "sleeve-ugi-reflux-post-1206-es.jpg",
  "size": 155069,
  "content_type": "image/jpeg",
  "created_at": "2026-09-28T16:44:13Z"
}
